// extracted by mini-css-extract-plugin
module.exports = {"head":"head-1WTRM","header":"header-2Y0S6","description":"description-RrVay"};